export const AutoReservationStatusQuery = {
  none: 'ジョブなし',
  reservation_queue: '予約開始前',
  reserving: '予約中',
  reserved: '予約完了',
  ticket_queue: '発券開始前',
  ticketing: '発券中',
  ticketed: '発券完了',
  full: '空席なし',
  failed: '失敗'
} as const;

export type AutoReservationStatusQueryKey = keyof typeof AutoReservationStatusQuery;

export const AutoReservationStatusQueryKeys: readonly AutoReservationStatusQueryKey[] = [
  'none',
  'reservation_queue',
  'reserving',
  'reserved',
  'ticket_queue',
  'ticketing',
  'ticketed',
  'full',
  'failed'
];

export const AutoReservationStatusQueryDefault: readonly AutoReservationStatusQueryKey[] = [
  'none',
  'full',
  'failed'
];
